// extracted by mini-css-extract-plugin
export default {"Root":"CountFactor_Root__vEO2a","Columns":"CountFactor_Columns__Jl8YY","Column":"CountFactor_Column__62N3f","Numpad":"CountFactor_Numpad__Q4US0"};